import React, {
  useState,
} from "react";

import axios from "axios";
import Swal from "sweetalert2";

import ObtieneDatosCookies
  from "../obtieneDatosCookiesUsuario";


// ============================================================
// API
// ============================================================

const API_BASE =
  "https://wwwa.isepsantafe.net.ar/expedientes";


// ============================================================
// COMPONENTE
// ============================================================

const ModuloCreaIncunvenciaDocentes = ({
  cerrarModal,
}) => {

  const Usuario =
    ObtieneDatosCookies();


  // ==========================================================
  // ESTADOS
  // ==========================================================

  const [
    nombreMateria,
    setNombreMateria,
  ] = useState("");

  const [
    categoriaId,
    setCategoriaId,
  ] = useState("");

  const [
    escuelasSeleccionadas,
    setEscuelasSeleccionadas,
  ] = useState([]);

  const [
    guardando,
    setGuardando,
  ] = useState(false);


  // ==========================================================
  // ESCUELAS
  // ==========================================================

  const escuelas = [
    "Escuela Superior",
    "Escuela de Especialidades",
    "Escuela de Policia",
    "Escuela de Investigaciones",
    "Extencion Comunitaria",
    "Extracurriculares",
    "Educacion a Distancia",
  ];


  // ==========================================================
  // SELECCIONAR / DESELECCIONAR ESCUELA
  // ==========================================================

  const alternarEscuela =
    (escuela) => {

      setEscuelasSeleccionadas(
        (anteriores) => {

          if (
            anteriores.includes(
              escuela
            )
          ) {

            return anteriores.filter(
              (item) =>
                item !== escuela
            );

          }

          return [
            ...anteriores,
            escuela,
          ];

        }
      );

    };


  // ==========================================================
  // GUARDAR INCUMBENCIA
  // ==========================================================

  const guardarIncumbencia =
    async (e) => {

      e.preventDefault();


      // ------------------------------------------------------
      // VALIDAR NOMBRE
      // ------------------------------------------------------

      if (
        !nombreMateria.trim()
      ) {

        Swal.fire({
          icon: "warning",
          title: "Dato requerido",
          text:
            "Debe ingresar el nombre de la materia.",
        });

        return;
      }


      // ------------------------------------------------------
      // VALIDAR CATEGORIA
      // ------------------------------------------------------

      if (!categoriaId) {

        Swal.fire({
          icon: "warning",
          title: "Dato requerido",
          text:
            "Debe seleccionar una categoría.",
        });

        return;
      }


      // ------------------------------------------------------
      // VALIDAR ESCUELAS
      // ------------------------------------------------------

      if (
        escuelasSeleccionadas.length ===
        0
      ) {

        Swal.fire({
          icon: "warning",
          title: "Dato requerido",
          text:
            "Debe seleccionar al menos una escuela.",
        });

        return;
      }


      // ------------------------------------------------------
      // DATOS PARA EL BACKEND
      // ------------------------------------------------------

      const datos = {

        nombreMateria:
          nombreMateria
            .trim()
            .toUpperCase(),

        categoriaId:
          Number(categoriaId),

        descripcion:
          escuelasSeleccionadas.join(
            ", "
          ),

        estado:
          "ACTIVO",

      };


      console.log(
        "DATOS A ENVIAR:",
        datos
      );


      try {

        setGuardando(true);


        // ----------------------------------------------------
        // POST
        // ----------------------------------------------------

        const response =
          await axios.post(

            `${API_BASE}/docentes/crearIncumbencia/`,

            datos,

            {
              withCredentials:
                true,
            }

          );


        console.log(
          "RESPUESTA CREAR INCUMBENCIA:",
          response.data
        );


        // ----------------------------------------------------
        // RESPUESTA OK
        // ----------------------------------------------------

        if (
          response.data?.ok
        ) {

          await Swal.fire({
            icon: "success",
            title:
              "Incumbencia creada",
            text:
              "La incumbencia fue creada correctamente.",
            confirmButtonText:
              "Aceptar",
          });


          // Limpiar formulario

          setNombreMateria("");

          setCategoriaId("");

          setEscuelasSeleccionadas(
            []
          );

        } else {

          Swal.fire({
            icon: "error",
            title:
              "No se pudo crear",
            text:
              response.data?.message ||
              response.data?.mensaje ||
              "El servidor no confirmó la creación de la incumbencia.",
          });

        }


      } catch (error) {

        console.error(
          "ERROR CREANDO INCUMBENCIA:",
          error
        );


        Swal.fire({
          icon: "error",
          title:
            "Error",
          text:
            error.response?.data?.message ||
            error.response?.data?.mensaje ||
            "No se pudo crear la incumbencia.",
        });


      } finally {

        setGuardando(false);

      }

    };


  // ==========================================================
  // RENDER
  // ==========================================================

  return (

    <div
      style={
        styles.contenedor
      }
    >

      <form
        onSubmit={
          guardarIncumbencia
        }
        style={
          styles.formulario
        }
      >

        {/* ==================================================
            CABECERA
        ================================================== */}

        <div
  style={
    styles.cabecera
  }
>

  <div
    style={
      styles.cabeceraSuperior
    }
  >

    <h2
      style={
        styles.titulo
      }
    >
      Crear Incumbencia
    </h2>

    <button
      type="button"
      onClick={cerrarModal}
      style={
        styles.botonCerrar
      }
    >
      Cerrar
    </button>

  </div>


  <div
    style={
      styles.subtitulo
    }
  >
    Nueva incumbencia docente
  </div>

</div>


        {/* ==================================================
            NOMBRE DE MATERIA
        ================================================== */}

        <div
          style={
            styles.campo
          }
        >

          <label
            htmlFor="CreaInc-nombreMateria"
            style={
              styles.label
            }
          >
            Nombre de Materia
          </label>

          <input
            type="text"
            id="CreaInc-nombreMateria"
            value={
              nombreMateria
            }
            onChange={(e) =>
              setNombreMateria(
                e.target.value
              )
            }
            placeholder="Ingrese el nombre de la materia"
            autoComplete="off"
            style={
              styles.input
            }
          />

        </div>


        {/* ==================================================
            CATEGORIA
        ================================================== */}

        <div
          style={
            styles.campo
          }
        >

          <label
            htmlFor="CreaInc-categoriaId"
            style={
              styles.label
            }
          >
            Categoría
          </label>

          <select
            id="CreaInc-categoriaId"
            value={
              categoriaId
            }
            onChange={(e) =>
              setCategoriaId(
                e.target.value
              )
            }
            style={
              styles.select
            }
          >

            <option
              value=""
              disabled
            >
              Seleccione categoría
            </option>

            <option value="1">
              ACADEMICA
            </option>

            <option value="2">
              OPERACIONAL
            </option>

          </select>

        </div>


        {/* ==================================================
            ESCUELAS
        ================================================== */}

        <div
          style={
            styles.campo
          }
        >

          <label
            style={
              styles.label
            }
          >
            Escuelas
          </label>


          <div
            style={
              styles.grupoEscuelas
            }
          >

            {escuelas.map(
              (escuela) => {

                const seleccionada =
                  escuelasSeleccionadas.includes(
                    escuela
                  );


                return (

                  <button
                    key={
                      escuela
                    }
                    type="button"
                    onClick={() =>
                      alternarEscuela(
                        escuela
                      )
                    }
                    style={{
                      ...styles.botonEscuela,

                      ...(seleccionada
                        ? styles.botonEscuelaSeleccionada
                        : {}),
                    }}
                  >

                    {escuela}

                  </button>

                );

              }
            )}

          </div>

        </div>


        {/* ==================================================
            RESUMEN DE ESCUELAS
        ================================================== */}

        {escuelasSeleccionadas.length >
          0 && (

          <div
            style={
              styles.resumenEscuelas
            }
          >

            <div
              style={
                styles.resumenTitulo
              }
            >
              Escuelas seleccionadas
            </div>

            <div
              style={
                styles.resumenTexto
              }
            >
              {
                escuelasSeleccionadas.join(
                  ", "
                )
              }
            </div>

          </div>

        )}


        {/* ==================================================
            ESTADO
        ================================================== */}

        <div
          style={
            styles.estado
          }
        >

          <span>
            Estado de la incumbencia:
          </span>

          <strong>
            ACTIVO
          </strong>

        </div>


        {/* ==================================================
            BOTON GUARDAR
        ================================================== */}

        <button
          type="submit"
          disabled={
            guardando
          }
          style={{
            ...styles.botonGuardar,

            ...(guardando
              ? styles.botonDeshabilitado
              : {}),
          }}
        >

          {guardando
            ? "Guardando..."
            : "Guardar Incumbencia"}

        </button>

      </form>

    </div>

  );

};


// ============================================================
// ESTILOS
// ============================================================

const styles = {

  contenedor: {
    width: "100%",
    boxSizing:
      "border-box",
  },


  formulario: {
    width: "100%",
    maxWidth:
      "650px",
    margin:
      "0 auto",
    boxSizing:
      "border-box",
  },


  cabecera: {
    marginBottom:
      "20px",
  },


  titulo: {
    margin: 0,
    fontSize:
      "24px",
    fontWeight:
      "800",
  },


  subtitulo: {
    marginTop:
      "4px",
    fontSize:
      "13px",
    opacity:
      0.6,
  },


  campo: {
    marginBottom:
      "18px",
  },


  label: {
    display:
      "block",
    marginBottom:
      "7px",
    fontSize:
      "13px",
    fontWeight:
      "800",
  },


  input: {
    width:
      "100%",
    boxSizing:
      "border-box",
    padding:
      "10px 12px",
    border:
      "1px solid #ccc",
    borderRadius:
      "7px",
    fontSize:
      "14px",
    outline:
      "none",
  },


  select: {
    width:
      "100%",
    boxSizing:
      "border-box",
    padding:
      "10px 12px",
    border:
      "1px solid #ccc",
    borderRadius:
      "7px",
    fontSize:
      "14px",
    background:
      "white",
    cursor:
      "pointer",
  },


  grupoEscuelas: {
    display:
      "flex",
    flexWrap:
      "wrap",
    gap:
      "7px",
  },


  botonEscuela: {
    border:
      "1px solid #ccc",
    background:
      "white",
    borderRadius:
      "7px",
    padding:
      "8px 11px",
    fontSize:
      "12px",
    cursor:
      "pointer",
    transition:
      "all 0.15s ease",
  },


  botonEscuelaSeleccionada: {
    background:
      "#dff4ed",
    border:
      "1px solid #66ad94",
    fontWeight:
      "800",
  },


  resumenEscuelas: {
    marginBottom:
      "16px",
    padding:
      "10px 12px",
    border:
      "1px solid #d8e7e1",
    borderRadius:
      "7px",
    background:
      "#f5faf8",
  },


  resumenTitulo: {
    fontSize:
      "11px",
    fontWeight:
      "800",
    marginBottom:
      "4px",
  },


  resumenTexto: {
    fontSize:
      "12px",
    lineHeight:
      1.5,
  },


  estado: {
    display:
      "flex",
    justifyContent:
      "space-between",
    alignItems:
      "center",
    padding:
      "10px 12px",
    marginBottom:
      "18px",
    border:
      "1px solid #ddd",
    borderRadius:
      "7px",
    background:
      "#fafafa",
    fontSize:
      "12px",
  },


  botonGuardar: {
    width:
      "100%",
    border:
      "none",
    borderRadius:
      "7px",
    padding:
      "11px 15px",
    background:
      "#222",
    color:
      "white",
    fontSize:
      "14px",
    fontWeight:
      "800",
    cursor:
      "pointer",
  },


  botonDeshabilitado: {
    opacity:
      0.6,
    cursor:
      "not-allowed",
  },

  cabeceraSuperior: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "15px",
},

botonCerrar: {
  border: "1px solid #ccc",
  background: "#f5f5f5",
  color: "#333",
  borderRadius: "7px",
  padding: "7px 14px",
  fontSize: "13px",
  fontWeight: "700",
  cursor: "pointer",
  transition: "all 0.15s ease",
},


};


export default ModuloCreaIncunvenciaDocentes;